import { useState } from "react";
import { FileText, Trash2, ArrowUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

function EventosList({ eventos, onSelect, onDelete }) {
  const [ordenPor, setOrdenPor] = useState("fecha"); // "fecha" o "hecho"

  if (eventos.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500 text-sm">
        No hay hechos registrados
      </div>
    );
  }

  // Ordenar eventos según selección
  const eventosOrdenados = [...eventos].sort((a, b) => {
    if (ordenPor === "fecha") {
      return new Date(a.fecha_evento) - new Date(b.fecha_evento);
    } else {
      return a.numero_hecho - b.numero_hecho;
    }
  });

  return (
    <>
      {/* Selector de ordenamiento */}
      <div className="p-3 bg-gray-50 border-b">
        <div className="flex items-center gap-2 mb-2">
          <ArrowUpDown className="h-4 w-4 text-gray-600" />
          <span className="text-xs font-semibold text-gray-700">Ordenar:</span>
        </div>
        <Select value={ordenPor} onValueChange={setOrdenPor}>
          <SelectTrigger className="w-full h-8 text-xs" data-testid="orden-selector-list">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="fecha">
              📅 Por Fecha
            </SelectItem>
            <SelectItem value="hecho">
              🔢 Por Número
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="divide-y" data-testid="eventos-list">
        {eventosOrdenados.map((evento) => (
        <div
          key={evento.id}
          className="p-3 hover:bg-gray-50 transition-colors cursor-pointer group"
          onClick={() => onSelect(evento)}
          data-testid={`evento-item-${evento.id}`}
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <FileText className="h-4 w-4 text-blue-600" />
                <span className="text-xs font-semibold text-blue-900">HECHO {evento.numero_hecho}</span>
                {evento.autor_tipo === "ia" && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-violet-100 text-violet-800 border border-violet-300 font-medium" data-testid={`autoria-lista-${evento.id}`}>IA · {evento.autor_nombre || "Claude"}</span>
                )}
              </div>
              <h4 className="text-sm font-medium text-gray-900 mb-1">{evento.titulo_evento}</h4>
              <p className="text-xs text-gray-500">
                {new Date(evento.fecha_evento).toLocaleDateString('es-CL')}
              </p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              className="opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(evento.id);
              }}
              data-testid={`delete-evento-${evento.id}`}
            >
              <Trash2 className="h-4 w-4 text-red-600" />
            </Button>
          </div>
        </div>
      ))}
      </div>
    </>
  );
}

export default EventosList;
